import styled from "styled-components";

import { theme } from "../../../../styles/theme";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  max-width: 400px;
  margin: 0 auto;
  justify-content: center;
`;

export const SubTitle = styled.h3`
  font-size: ${theme.font.sizes.xxsmall};
  font-weight: ${theme.font.normal};
  color: ${theme.colors.gray400};
  text-align: center;
`;

export const Title = styled.h1`
  font-size: ${theme.font.sizes.xxlarge};
  font-weight: ${theme.font.bold};
  color: ${theme.colors.white};
  text-align: center;
  margin-bottom: 40px;
`;

export const Logo = styled.img`
  width: 165px;
  height: 61px;
  margin: 0 auto;
  margin-bottom: 40px;
`;
